<template>
  <div :style="!is_auth ? 'height: 100%;' : ''">
    <div class="home" style="width: 100%">
      <div v-if="!show && is_auth === 0">
        <img class="homepic" src="@/assets/4.png">
        <div style="margin: 20px auto;">
          <div class="text1">您的身份信息暂未完善请前往提交</div>
          <div class="text2">Your identity information is not yet complete. Please go and submit it</div>
        </div>
        <el-button type="primary" @click="show = true">去完善身份信息</el-button>
      </div>
      <completeInformation v-if="show" />
    </div>
    <Cmy :level="level" v-if="!show && is_auth === 1" />
  </div>
</template>

<script>
import { api1, api2, api3, api4, api6 } from '@/api/index.js'
import Cmy from '../../components/Cmy.vue'
import completeInformation from '../../components/completeInformation.vue'


export default {
  data() {
    return {
      show: false,
      is_auth: '',
      is_auth_check: '',
      level: ''
    }
  },
  components: { Cmy, completeInformation },
  mounted() {
    this.qx()
  },
  methods: {
    qx() {
      api6({ id: JSON.parse(localStorage.getItem('userInfo')).id }).then(res => {
        if (res.data.code === 1) {
          // 1:已认证  0：未认证
          this.is_auth = res.data.data.user.is_auth
          this.is_auth_check = res.data.data.user.is_auth_check
          this.level = res.data.data.user.level//级别


        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
  }
}
</script>

<style scoped>
.tishi {
  font-weight: 400;
  font-size: 14px;
  color: #E90000;
  margin-top: 20px;
}

.pm-box {
  width: 100%;
  height: 100%;
  padding: 10px 25px;
  box-sizing: border-box;
  background: #fff;
}

.text2 {
  font-weight: 400;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.45);
  line-height: 28px;
}

.text1 {
  font-weight: 400;
  font-size: 40px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 41px;
}

.homepic {
  width: 328px;
  height: 379px;
}

.home {
  width: 100%;
  height: 100%;
  background: #fff;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/view/MY/my.vue